import React, { forwardRef, useState } from 'react';

import PasswordEye from './PasswordEye';
import './form.css';

const FormTextInput = forwardRef(
function ForwaredRefFormTextInput({
  id,
  label,
  name,
  type,
  defaultValue = '',
  value: ignored,
  title,
  getValidationError = value => undefined,
  ...rest
}, ref) {

  const [value, setValue] = useState(defaultValue);
//  const [validationError, setValidationError] = useState(defaultValue ? getValidationError(defaultValue) : undefined);
  const [validationError, setValidationError] = useState(undefined);
  const [passwordVisible, setPasswordVisible] = useState(type === 'password' ? false : undefined);
  const [focused, setFocused] = useState(defaultValue);

  if (ignored) {
    console.error('Do not try to set the value prop of the FormTextInput component, use defaultValue instead!');
  }

  return (
    <section className={`${focused ? 'focused ' : ''}${ validationError ? '' : 'valid '}input`}>
      <label
        htmlFor={id}
        title={title}
      >
        {label}
        <input
        id={id}
        className={(name) ? 'has-content' : ''}
        ref={ref}
        type={passwordVisible ? 'text' : type}
        title={title}
        name={name}
        defaultValue={value}
        onFocus={() => { 
          setFocused(true);
        }}
        onChange={(event) => {
          const { value } = event.target;
          const currentError = getValidationError(value);
          if (!currentError) {
            setValidationError(currentError);
          }
          setValue(value);
        }}
        onBlur={(event) => {
          const { value } = event.target;
          setValue(value);
          setValidationError(getValidationError(value));
          setFocused(false);
        }}
        { ...rest }
      />

      </label>
      { type === 'password'
        ? <PasswordEye visible={passwordVisible} setVisible={setPasswordVisible} />
        : undefined
      }
      <p className={`error${validationError ? ' active' : ''}`}>
        {validationError || <span>&nbsp;</span>}
      </p>
    </section>
  );
});

export default FormTextInput;
